module.exports = __webpack_public_path__ + "img/854-f066dd.png";